import React from "react";
import "./Background.scss";
import useAboutUs from "../../../hooks/useAboutUs";
import backgroundBg from "../../../assets/About/back-bg.png";
import backAbout from "../../../assets/About/back-about.png";

const Background = () => {
  const [aboutUs, setAboutUs] = useAboutUs();

  const backgroundData = aboutUs.filter(
    (vision) => vision.DescType === "OUR BACKGROUND"
  );
  // console.log("Background Data", backgroundData);

  return (
    <>
      <div className="company_background">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${backgroundBg})` }}
            data-aos="fade-down"
          ></div>
          <div className="heading_box">
            <span data-aos="fade-right">Background</span>
          </div>
          <div className="container">
            <div className="background_content">
              <div className="row justify-content-between">
                <div className="col-lg-6 my-auto">
                  <div className="left">
                    <h3>{backgroundData[0]?.Title}</h3>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="right">
                    <img src={backAbout} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>

              <div
                className="description"
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="500"
              >
                <p>{backgroundData[0]?.Description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Background;
